import React, { useState, useEffect } from 'react'
import { IconButton } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    iconButton: {
      
    },
  });


const PaginationComponent = (props: any) => {
    const classes = useStyles();
    const { pageSize = 5, onPaginationChange, total = 0,noRecordPerpage } = props;
    const [pageIndex, setPageIndex] = useState(1);

    const totalNumberOfPages = Math.ceil(total / pageSize)

    useEffect(() => {
       
        const value = pageSize * pageIndex;
        onPaginationChange(value - pageSize, value)
    
    }, [pageIndex]);

    const onButtonClick = (type: any, e: any) => {
        if (type === "prev") {
            if (pageIndex === 1) {
                setPageIndex(1)
            } else {
                setPageIndex(pageIndex - 1)
            }
        } else if (type === 'next') {
            if (totalNumberOfPages === pageIndex) {
                setPageIndex(pageIndex)
            } else {
                setPageIndex(pageIndex + 1)
            }
        }
    }
    return (
        <div className='d-flex justify-content-between'>
            <div>
                <IconButton
                    title="Previous"
                   // onClick={(e: any) => onButtonClick("prev", e)}
                >
                    <ArrowBackIosIcon fontSize="small" style={{width:'15px'}}/>
                </IconButton>

                {/* <span>
                    {pageIndex} &nbsp;/ &nbsp;{totalNumberOfPages} page  of &nbsp;
                    {total} records
                </span> */}
                 <span>
                   {noRecordPerpage} / {total} records
                </span>
                <IconButton
                    title="Next"
                   // onClick={(e: any) => onButtonClick("next", e)}
                >
                    <ArrowForwardIosIcon fontSize="small"style={{width:'15px'}} />
                </IconButton>
            </div>
        </div>
    )
}

export default PaginationComponent